// extracted by mini-css-extract-plugin
module.exports = {"page":"page--37FnX","page_container":"page_container--x5KCN","loading":"loading--24f0e","player_btn":"player_btn--UPGcf","player_controlbar":"player_controlbar--2VsHy"};